import { combineReducers } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useSelector } from "react-redux";

import applicationReducer from "../slices/applicationSlice";
import codeBookReducer from "../slices/codeBookSlice";
import institutionReducer from "../slices/institutionSlice";
import pedagogicalYearReducer from "../slices/pedagogicalYearSlice";
import personReducer from "../slices/personSlice";
import questionnaireReducer from "../slices/questionnaireSlice";
import requestReducer from "../slices/requestSlice";

const rootReducer = combineReducers({
  application: applicationReducer,
  pedagogicalYear: pedagogicalYearReducer,
  person: personReducer,
  request: requestReducer,
  questionnaire: questionnaireReducer,
  codeBook: codeBookReducer,
  institution: institutionReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export default rootReducer;
